<template>
  <div v-if="titles.length > 0">
    <p class="text-xl font-medium mb-4">Titles</p>
    <TitlesView :meta="meta" :titles />
    <NamiDivider />
  </div>
</template>

<script setup lang="ts">
import type { TitleEntity, Meta } from "~/src/api";

const props = defineProps<{
  titles: TitleEntity[];
  meta: Meta;
}>();
</script>
